import Toilet1 from "@/assets/clients/tempula/room/paiyuu/Toilet-1.webp"
import Toilet2 from "@/assets/clients/tempula/room/paiyuu/Toilet-2.webp"
import Balcony1 from "@/assets/clients/tempula/room/paiyuu/balcony-1.webp"
import Balcony2 from "@/assets/clients/tempula/room/paiyuu/balcony-2.webp"
import Balcony3 from "@/assets/clients/tempula/room/paiyuu/balcony-3.webp"
import Balcony4 from "@/assets/clients/tempula/room/paiyuu/balcony-4.webp"
import Balcony5 from "@/assets/clients/tempula/room/paiyuu/balcony-5.webp"
import Balcony6 from "@/assets/clients/tempula/room/paiyuu/balcony-6.webp"

import Misc1 from "@/assets/clients/tempula/room/paiyuu/misc-1.webp"
import Misc2 from "@/assets/clients/tempula/room/paiyuu/misc-2.webp"
import Misc3 from "@/assets/clients/tempula/room/paiyuu/misc-3.webp"
import Misc4 from "@/assets/clients/tempula/room/paiyuu/misc-4.webp"
import Misc5 from "@/assets/clients/tempula/room/paiyuu/misc-5.webp"
import Misc6 from "@/assets/clients/tempula/room/paiyuu/misc-6.webp"
import Misc7 from "@/assets/clients/tempula/room/paiyuu/misc-7.webp"


import Bedrooom1 from "@/assets/clients/tempula/room/paiyuu/bedroom-1.webp"
import Bedrooom2 from "@/assets/clients/tempula/room/paiyuu/bedroom-2.webp"
import Bedrooom6 from "@/assets/clients/tempula/room/paiyuu/bedroom-6.webp"
import Bedrooom12 from "@/assets/clients/tempula/room/paiyuu/bedroom-12.webp"
import Bedrooo16 from "@/assets/clients/tempula/room/paiyuu/bedroom-16.webp"




const paiyuuConfig = {
    subInfo: "3 guests · 1 bedroom · 1 bed · 1 private bathroom",
    subInfoClass: "text-xl md:text-2xl text-white font-extralight",

    sections: [
        {
            title: "Bedroom",
            images: [Bedrooom1, Bedrooom2, Bedrooom6 , Bedrooom12 , Bedrooo16],
        },
        {
            title: "Bathroom",
            images: [Toilet1, Toilet2],
        },
        {
            title: "Balcony",
            images: [Balcony1, Balcony2, Balcony3, Balcony4, Balcony5, Balcony6],
        },
        {
            title: "Miscellaneous",
            images: [Misc1, Misc2, Misc3, Misc4, Misc5, Misc6, Misc7],
        },
    ],

};
export default paiyuuConfig;
